import React, { Component } from 'react';
import { view, save, update } from './restApi';
import dotAccess from 'dot-access';
import { InvertedButtonLink } from '../components/output/ButtonLink';
import { SubmitButton } from '../components/output/Button';
import InputPassword from '../components/input/InputPassword';
import Modal, { ConfirmModal } from '../components/container/Modal';
import { classNames } from '../functions/classNames';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import './Crud.css';

const deepGet = (resource, name) => {
  const value = name ? dotAccess.get(resource, name) : resource;
  return (value !== undefined && value !== null) ? value : '';
};

class Edit extends Component {
  constructor(props, context) {
    super(props, context);

    const initialResource = props.initialValue ? props.initialValue : {};
    const isInitialLoading = props.entityId ? true : false;
    this.state = {
      resource: initialResource,
      isLoading: isInitialLoading,
      err: this.validate(initialResource),
      lock: isInitialLoading,
    };
  }

  componentDidMount = () => {
    const { entityName, entityId } = this.props;
    if (entityId) {
      view(entityName, entityId)
        .then(data => {
          this.setState({
            resource: data,
            isLoading: false,
            lock: false,
            err: this.validate(data),
          });
        })
        .catch(this.handleRemoteErrors);
    }
  };

  closeModal = () => {
    this.setState({ showModal: false, modalError: '' });
  };

  closeConfirmModal = () => {
    this.setState({ showConfirmModal: false, confirmContent: '' });
  };

  closeSignModal = () => {
    let updated = { ...this.state.resource };
    updated.signature = '';

    this.setState({
      showSignModal: false,
      resource: updated,
    });
  };

  validate = (form) => {
    const errors = { hasErrors: false };
    const { validators } = this.props;
    if (validators) {
      validators.forEach(validate => validate(form, errors));
    }

    return errors;
  };

  handleLockSubmit = (value) => {
    this.setState({ lock: value });
  };

  resourceRefresh = debounce(() => {
    const { refreshFrom } = this.props;
    const { resource } = this.state;

    if (!refreshFrom) {
      return;
    }

    save(refreshFrom, resource)
      .then(data => {
        this.setState({ resource: data });
      })
      .catch(this.handleRemoteErrors);
  }, 500);

  handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    let updated = { ...this.state.resource };
    dotAccess.set(updated, name, value);

    const errors = this.validate(updated);
    const showErrors = this.state.showErrors && errors.hasErrors;

    this.setState({
      resource: updated,
      err: errors,
      showErrors: showErrors,
    }, this.resourceRefresh);
  };

  handlePasswordChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    let updated = { ...this.state.resource };
    dotAccess.set(updated, name, value);

    this.setState({ resource: updated });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    // se è lockato, non fa niente
    if (this.state.lock) {
      return;
    }

    // controlla errori
    if (this.state.err.hasErrors) {
      this.setState({ showErrors: true });
      return;
    }

    // esegue il preSubmit
    if (this.props.preSubmit) {
      this.props.preSubmit(this.state.resource)
          .then(res => {
            if (res.value === true) {
              this.setState({
                showConfirmModal: true,
                confirmContent: getLabel(this.context.locale, 'cruds.edit.errors.evaluation'),
              });
            } else {
              this.handleRealSubmit();
            }
          });
      return;
    }

    // controlla warnings
    if (this.state.err.hasWarnings) {
      this.setState({
        showConfirmModal: true,
        confirmContent: this.renderWarnings(this.state.err.warnings, this.context.locale),
      });
      return;
    }

    // esegue la firma
    if (this.props.signed) {
      this.setState({ showSignModal: true });
      return;
    }

    this.setState({
      lock: true,
    }, this.handleRealSubmit)
  };

  handleRealSubmit = () => {
    const { entityName, entityId, entityRoute, history } = this.props;
    const data = this.state.resource;

    if (entityId) {
      update(entityName, entityId, data)
        .then(() => history.push('/' + entityRoute))
        .catch(entityName !==  "departments" ? this.handleRemoteErrors : this.handleGoDisableRemoveErrors);

    } else {
      save(entityName, data)
        .then(() => history.push('/' + entityRoute))
        .catch(this.handleRemoteErrors);
    }
  };

  handleRemoteErrors = err => (
    this.setState({
      showModal: true,
      isLoading: false,
      lock: false,
      showConfirmModal: false,
      showSignModal: false,
      modalError: err.message,
    }));
  
  handleGoDisableRemoveErrors = err => (
		    this.setState({
		        showModal: true,
		        isLoading: false,
		        lock: false,
		        showConfirmModal: false,
		        showSignModal: false,
		        modalError: err.message,
    }));

  
  
  
  renderWarnings = (warnings, locale) => (
    <div className="warnings">
      {getLabel(locale, 'cruds.warningText')}
      <ul>
        { Object.keys(warnings)
            .map((k, i) => <li key={i}>{getLabel(locale, warnings[k])}</li>) }
      </ul>
    </div>
  );

  renderErrors = (err, locale) => (
    <div className="errors">
      <ul>
        { Object.keys(err.errors)
            .map((k, i) => <li key={i}>{getLabel(locale, err.errors[k])}</li>) }
      </ul>
    </div>
  );

  renderChildren = () => (
    React.Children.map(this.props.children,
      child => React.cloneElement(child, {
        value: deepGet(this.state.resource, child.props.name),
        handleChange: this.handleChange,
        handleLockSubmit: this.handleLockSubmit,
        resource: this.state.resource,
        error: this.state.showErrors && deepGet(this.state.err.errors, child.props.name),
      })
    )
  );

  render() {
    const { title, overrideTitle, entityRoute, entityId } = this.props;
    const { locale } = this.context;
    const { showErrors, err } = this.state;

    return (
      <div className={classNames('Crud', 'Edit', this.props.crudClassName)}>
        <h2>
          { overrideTitle ? getLabel(locale, overrideTitle) :
              getLabel(locale, (entityId ? 'general.modify' : 'general.add')) + ' ' + getLabel(locale, title)
          }
        </h2>
        {showErrors && err.hasErrors ? this.renderErrors(err, locale) : '' }
        <form onSubmit={this.handleSubmit}>
          {this.state.isLoading ? '' : this.renderChildren()}
          <SubmitButton disabled={this.state.lock} label="general.save" />
          <InvertedButtonLink
              to={'/' + entityRoute}
              label="general.cancel"
              style={{ marginLeft: '10px' }}
          />
          <Modal isOpen={this.state.showModal}
              title="general.errorOccurred"
              handleCloseModal={this.closeModal}
          >
            <div style={{ padding: 20 }}>{this.state.modalError}</div>
          </Modal>
        </form>
        <ConfirmModal
            title="general.confirm.title"
            isOpen={this.state.showConfirmModal}
            submitAction={this.handleRealSubmit}
            handleCloseModal={this.closeConfirmModal}
        >
          <div className="signature-modal">
            {this.state.confirmContent}
          </div>
        </ConfirmModal>
        <ConfirmModal
            title="general.signature.title"
            isOpen={this.state.showSignModal}
            submitAction={this.handleRealSubmit}
            handleCloseModal={this.closeSignModal}
        >
          <div className="signature-modal">
            <div>{getLabel(locale, 'general.signature.text')}</div>
            <InputPassword name="signature" handleChange={this.handlePasswordChange} />
          </div>
        </ConfirmModal>
        </div>
    );
  }
}

Edit.contextTypes = {
  locale: PropTypes.string,
};

export default Edit;



// WEBPACK FOOTER //
// ./src/main/cruds/Edit.js